import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { VisitObjective } from '../../models/lookups/visitObjective.model';

@Injectable({
  providedIn: 'root'
})
export class VisitObjectiveService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(visitObjective: VisitObjective) {
    return this.http.post(this.configurations.apiAddress + "/api/VisitObjective/save", visitObjective);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/VisitObjective/search', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/VisitObjective/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/VisitObjective/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/VisitObjective/getAll/');
  }

}
